import { FC, ReactNode } from 'react'
import styled from 'styled-components'
import { PRINT_PLAN_QUEUE_COLUMN_WIDTH } from '../../../../constants/print-plan-layout'

const Column = styled.div`
    flex: 0 0 ${PRINT_PLAN_QUEUE_COLUMN_WIDTH}px;
    width: ${PRINT_PLAN_QUEUE_COLUMN_WIDTH}px;
    height: 100%;
    min-width: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`

const Header = styled.div`
    flex: 0 0 auto;
    padding: 9px 12px;
    border-bottom: 1px solid ${({ theme }) => theme.colorBorder};
`

const QueueLayout = styled.div`
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
`

const MainQueue = styled.div`
    height: 70%;
    position: relative;
    min-height: 0;
`

const WaitingQueue = styled.div`
    height: 30%;
    min-height: 0;
`

interface QueueColumnProps {
    title: ReactNode
    mainQueue: ReactNode
    waitingQueue?: ReactNode
}

const QueueColumn: FC<QueueColumnProps> = ({ title, mainQueue, waitingQueue }) => {
    return (
        <Column>
            <Header>{title}</Header>
            <QueueLayout>
                <MainQueue>{mainQueue}</MainQueue>
                {waitingQueue && <WaitingQueue>{waitingQueue}</WaitingQueue>}
            </QueueLayout>
        </Column>
    )
}

export default QueueColumn
